import React, { useState, useEffect } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import { showAlert } from "../../../../../customComponents/CustomSweetAlert/ShowAlert";

const EditMake = () => {
  const [formData, setFormData] = useState({});
  const [productOptions, setProductOptions] = useState([]);
  const [subProductOptions, setSubProductOptions] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const location = useLocation();
  const { data } = location.state || {};
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = data?.business_partner_id;
  const [userTypedd, setUserTypedd] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchMakeProduct();
  }, []);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axiosInstance.post(
          "/product/ddlproduct",
          {
            orderBy: "product_id desc",
            page: 0,
            pageSize: 1000,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const productList = response.data.data.data.map((product) => ({
          label: product.NAME,
          value: product.ID,
        }));

        setProductOptions(productList);
      } catch (error) {
        console.error("Error fetching product list:", error);
      }
    };

    fetchProducts();
  }, []);

  useEffect(() => {
    const fetchSubproducts = async () => {
      if (!formData.productName) return;

      try {
        const response = await axiosInstance.post(
          "/subproduct/ddlsubproduct",
          {
            product_id: formData.productName,
            orderBy: "subproduct_id desc",
            page: 0,
            pageSize: 1000,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );

        const subproductList = response.data.data.data.map((subproduct) => ({
          label: subproduct.NAME,
          value: subproduct.ID,
        }));

        setSubProductOptions(subproductList);
      } catch (error) {
        console.error("Error fetching subproduct list:", error);
      }
    };

    fetchSubproducts();
  }, [formData?.productName]);

  const fetchMakeProduct = async () => {
    try {
      const response = await axiosInstance.get(`/make/edit/${data.make_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const fetchedData = response.data.data;
      console.log("fetchedData", fetchedData);

      setFormData({
        business_partner_id: fetchedData.business_partner_id,
        productName: fetchedData.product_id,
        subproductName: fetchedData.subproduct_id,
        makeName: fetchedData.make_name,
        makeDesc: fetchedData.make_desc,
        status: fetchedData.status == 1 ? true : false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    try {
      // Confirm with the user before updating
      const confirmation = await showAlert({
        title: "Confirmation",
        text: "Are you sure you want to update this record in Make?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // If the user cancels, exit early
      if (!confirmation.isConfirmed) {
        return;
      }

      setLoading(true);
      const payload = {
        product_id: formData.productName,
        subproduct_id: formData.subproductName,
        make_name: formData.makeName,
        make_desc: formData.makeDesc,
        status: formData.status === true ? 1 : 0,
      };

      const response = await axiosInstance.patch(
        `/make/update/${data.make_id}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      console.log("API Response:", response.data);

      // Show success alert after a successful update
      await showAlert({
        title: "Success",
        text: "Make updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      // Navigate after user clicks OK
      navigate("/admin/manage-product/make");
    } catch (error) {
      console.error("Error submitting form:", error);

      // Show error alert in case of a failure
      showAlert({
        title: "Update Failed",
        text: "An error occurred while updating the Make record.",
        icon: "error",
        confirmButtonText: "OK",
      });

      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const formConfig = [
    {
      name: "productName",
      label: "Product Name",
      type: "dropdown",
      required: true,
      options: productOptions,
      gridClass: "col-lg-4",
    },
    {
      name: "subproductName",
      label: "Subproduct Name",
      type: "dropdown",
      options: subProductOptions,
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "makeName",
      label: "Make Name",
      type: "text",
      required: true,
      validation: {
        required: true,
        pattern: /^[A-Za-z\s]*$/,
        message: "Only alphabets are allowed",
      },
      gridClass: "col-lg-4",
    },
    {
      name: "makeDesc",
      label: "Make Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },

    {
      name: "status",
      label: "Status",
      type: "toggle",
      required: true,

      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div
              className="backbutton mt-2 mb-2"
              onClick={() => navigate(ROUTES_NAVIGATION.MAKELIST)}
            >
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Edit Make</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please Edit Make Details
              </span>
              <DynamicForm
                formConfig={formConfig}
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>
            <div className="btncontainer mt-3">
              <button
                onClick={() => handleFormSubmit(formData)}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditMake;
